define('areas/shopitemtemplate/models/bindable',["require", "exports"], function (require, exports) {
    "use strict";
    var TemplateVM = (function () {
        function TemplateVM() {
            ko.track(this);
        }
        return TemplateVM;
    }());
    exports.TemplateVM = TemplateVM;
    var ShopItemStubVM = (function () {
        function ShopItemStubVM() {
            ko.track(this);
        }
        return ShopItemStubVM;
    }());
    exports.ShopItemStubVM = ShopItemStubVM;
});

